import { css } from 'linaria';
import { Variables } from '../index';

export const root = css`
    background: ${Variables.css.catapultBlack};
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    padding: 0 ${Variables.css.spacing16};
`;

export const primaryNavWrapper = css`
    display: flex;
    align-items: center;
    height: 100%;
    gap: ${Variables.css.spacing16};
    margin-left: ${Variables.css.spacing16};
`;

export const active = css`
    &:before {
        content: '';
        cursor: default;
        position: absolute;
        height: 4px;
        width: 100%;
        background: ${Variables.css.catapultOrange};
        bottom: -18px;
    }
`;

export const link = css`
    cursor: pointer;
    overflow: visible;
`;
export const clickable = css``;
export const logo = css`
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 48px;
    min-width: 44px;

    &.${clickable} {
        cursor: pointer;
    }
`;

export const secondaryNavWrapper = css`
    display: flex;
    margin-left: auto;
`;

export const secondaryItemsWrapper = css`
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: ${Variables.css.spacing24};
    gap: ${Variables.css.spacing24};
`;

export const secondaryAvatarWrapper = css`
    display: flex;
    flex-direction: row;
`;
export const selected = css``;
export const unselected = css``;
export const avatarWrapper = css`
    display: flex;
    flex-direction: row;
    padding: ${Variables.css.spacing4};

    &.${selected} {
        background: ${Variables.css.selectedOverlay};
    }

    &.${unselected} {
        background: ${Variables.css.catapultBlack};
    }
`;

export const dropdown = css`
    background: ${Variables.css.catapultWhite};
    border-radius: ${Variables.css.spacing4};
    box-shadow: ${Variables.css.shadow3};
    position: absolute;
    right: ${Variables.css.spacing16};
    top: 72px;
    display: none;
    z-index: 1;
`;

export const dropdownActive = css`
    display: block;
`;
export const badge = css``;

export const avatarBadgeIndicator = css`
    color: ${Variables.css.catapultWhite};
    align-self: center;
    margin-left: ${Variables.css.spacing8};

    &.${badge} {
        margin-left: -12px;
    }
`;

export const avatarBadgeOffset = css`
    top: 28px;
    left: -18px;
`;
